import { keepPreviousData, queryOptions } from '@tanstack/react-query';
import { apiClient } from '@/api/axios';
import { API } from '@/api/endpoints';
import { STALE_TIME } from '@/api/staleTimes';
import {
  paginatedPcmpCorrectionQueueSchema,
  pcmpCorrectionQueueCountsSchema,
  type PaginatedPcmpCorrectionQueue,
  type PcmpCorrectionQueueCounts,
  type PcmpCorrectionQueueParams,
} from '../types/pcmpCorrection.types';
import type { PcmpQueueFilters } from '../types/pcmpQueue.types';

export const pcmpCorrectionQueryKeys = {
  all: () => ['pcmp-correction'] as const,
  queue: (params: PcmpCorrectionQueueParams) =>
    [...pcmpCorrectionQueryKeys.all(), 'queue', params] as const,
  counts: (filters: PcmpQueueFilters) =>
    [...pcmpCorrectionQueryKeys.all(), 'counts', filters] as const,
};

export const pcmpCorrectionQueueQueryOptions = (params: PcmpCorrectionQueueParams) =>
  queryOptions({
    queryKey: pcmpCorrectionQueryKeys.queue(params),
    queryFn: async (): Promise<PaginatedPcmpCorrectionQueue> => {
      const res = await apiClient.get(API.pcmpCorrection.queue, { params });
      return paginatedPcmpCorrectionQueueSchema.parse(res.data);
    },
    placeholderData: keepPreviousData,
    staleTime: STALE_TIME,
  });

export const pcmpCorrectionCountsQueryOptions = (filters: PcmpQueueFilters) =>
  queryOptions({
    queryKey: pcmpCorrectionQueryKeys.counts(filters),
    queryFn: async (): Promise<PcmpCorrectionQueueCounts> => {
      const res = await apiClient.get(API.pcmpCorrection.queueCounts, { params: filters });
      return pcmpCorrectionQueueCountsSchema.parse(res.data);
    },
    placeholderData: keepPreviousData,
    staleTime: STALE_TIME,
  });
